export default "__VITE_ASSET__BkS07qc$__"